export const isBinaryValue = (value) => {
    const hasFile = typeof File !== "undefined" && value instanceof File;
    const hasBlob = typeof Blob !== "undefined" && value instanceof Blob;
    return hasFile || hasBlob;
};

export const hasBinaryInForm = (form) => {
    return Object.values(form ?? {}).some((value) => {
        if (Array.isArray(value)) {
            return value.some(isBinaryValue);
        }
        return isBinaryValue(value);
    });
};

const toFormDataValue = (value) => (typeof value === "boolean" ? (value ? "1" : "0") : value);

export const toFormData = (form) => {
    const formData = new FormData();

    Object.entries(form ?? {}).forEach(([key, value]) => {
        if (value === null || value === undefined) return;

        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item === null || item === undefined) return;
                formData.append(key, toFormDataValue(item));
            });
            return;
        }

        formData.append(key, toFormDataValue(value));
    });

    return formData;
};

export const adaptPayload = (form) => {
    return hasBinaryInForm(form) ? toFormData(form) : form;
};

export const parseApiFieldErrors = (apiErrors) => {
    const result = {};
    Object.entries(apiErrors ?? {}).forEach(([campo, mensagens]) => {
        result[campo] = Array.isArray(mensagens) ? mensagens[0] : mensagens;
    });
    return result;
};

export const buildAlertError = (message) => ({_alert: [message]});

export const ERRO_GENERICO = buildAlertError("Erro ao salvar. Tente novamente.");

